export const setProduct = (state, payload) => (state.product = payload)
export const updateUncompletedTodos = (state, count) => (state.product.incomplete_to_dos_count = count)
export const setAllSubjectCategories = (state, payload) => (state.allSubjectCategories = payload)
export const addSubjectCategory = (state, payload) => state.allSubjectCategories.push(payload)
export const setAssignedSubjectCategories = (state, payload) => (state.assignedSubjectCategories = payload)
export const assignSubjectCategory = (state, payload) => state.assignedSubjectCategories.push(payload)
export const toggleFetchingSubjectCategories = (state, toggle) => (state.fetchingSubjectCategories = toggle)
export const setEditingData = (state, payload) => (state.editingData = payload)
export const setTitleLists = (state, payload) => (state.titleLists = payload)
export const setSubscriptions = (state, payload) => (state.subscriptions = payload)

export function removeActiveMainCategory(state) {
  const index = state.assignedSubjectCategories.findIndex(item => item.is_main_category === true)
  if (~index) {
    state.assignedSubjectCategories[index].is_main_category = false
  }
}

export function setActiveMainCategory(state, id) {
  const index = state.assignedSubjectCategories.findIndex(item => item.id === id)
  if (~index) {
    state.assignedSubjectCategories[index].is_main_category = true
  }
}

export function removeSubjectCategory(state, subjId) {
  const index = state.assignedSubjectCategories.findIndex(s => s.id === subjId)
  if (~index) state.assignedSubjectCategories.splice(index, 1)
}
